import { AdminUserResponse } from "../contracts/AdminUserResponse";
import { AdminUser } from "../models/AdminUser";

export const mapResponseToAdminUser = (response: AdminUserResponse): AdminUser => ({
  instructorId: response.instructorId,
  userAccountId: response.userAccountId,
  firstName: response.firstName,
  lastName: response.lastName,
  email: response.email,
  signupDate: new Date(response.signupDate),
  instructorStatus: response.instructorStatus,
  organizationRole: response.organizationRole,
  teamInstructorCount: response.teamInstructorCount,
  memberCount: response.memberCount,
  sessionCount: response.sessionCount ?? 0,
  contractCount: response.contractCount ?? 0,
  visitCount: response.visitCount ?? 0,
  lastActiveAt: response.lastActiveAt ? new Date(response.lastActiveAt) : null,
  hasSubscription: response.hasSubscription,
  subscriptionState: response.subscriptionState,
  trialEndsAt: response.trialEndsAt ? new Date(response.trialEndsAt) : null,
  trialDaysRemaining: response.trialDaysRemaining,
  isFoundingMember: response.isFoundingMember,
  hasProviderSubscription: response.hasProviderSubscription,
  complimentaryUntil: response.complimentaryUntil ? new Date(response.complimentaryUntil) : null,
  customMonthlyAmountMinorUnits: response.customMonthlyAmountMinorUnits,
  customAnnualAmountMinorUnits: response.customAnnualAmountMinorUnits,
  customPriceCurrency: response.customPriceCurrency,
  block: response.block ?? null,
  isDemo: response.isDemo ?? false,
});
